import { useContext, useEffect, useState } from 'react';
import LegoAdminPageContext from '../../../pages/legoAdminPageContext';

const schemaCache = {};

export default function useSchema(schemaId = 'last') {
  const { page } = useContext(LegoAdminPageContext);
  const [schema, setSchema] = useState(schemaCache[schemaId] || null);

  useEffect(() => {
    if(schemaId && !schemaCache[schemaId]) {    
      page.service('services/cerokm/schema').find({query: {$sort: {createdAt: -1}, $limit: 1}}).then(([data]) => {
        setSchema(data || false);
        schemaCache[schemaId] = data;
      }).catch(console.error);
    }
  }, [schemaId]);

  return schema;
}
